<template>
  <div class="geoproceso-form form-section">
    <!-- MODO DE SELECCIÓN -->
    <GeoprocesoSelectorModo v-model="otrasCapas" @input="onModeChange" />

    <!-- SELECCIÓN DE CAPA (Si aplica) -->
    <GeoprocesoSelectorCapa 
      v-model="capaOtrasSeleccionada"
      :otrasCapas="otrasCapas"
      :tipoInfluencia="'Radial'"
      :distancias="distancias"
      :dissolve="dissolve"
      @selection-complete="onSelectionComplete"
    />

    <!-- HERRAMIENTAS DE DIBUJO (Si aplica) -->
    <div v-if="!otrasCapas">
      <label>Ubique un punto</label>
      <button :class="['draw-btn', { 'draw-btn--active': drawActive }]" @click="drawPoint">●</button>
    </div>

    <label>Ingrese N° de radios o áreas de influencia:</label>
    <select v-model.number="radioSeleccionado" @change="refreshRadialBuffer">
      <option v-for="r in radios" :key="r" :value="r">{{ r }}</option>
    </select>

    <!-- Inputs dinámicos -->
    <div v-if="radioSeleccionado" class="distancias radial-distancias">
      <label>Ingrese distancias: (m)</label>
      <div class="distancia-inputs">
        <input
          v-for="(dist, index) in distancias"
          :key="index"
          type="number"
          :value="dist"
          :min="minimumDistance(index)"
          :disabled="isDistanceDisabled(index)"
          :class="{ 'distance-input-invalid': distanciaEsInvalida(index) }"
          placeholder="Distancia"
          @input="updateDistancia(index, $event.target.value)"
          @blur="normalizeDistancia(index)"
        />
      </div>
      <p v-if="!radiosValidos" class="distance-validation-message">
        {{ mensajeValidacionRadios }}
      </p>
    </div>

    <GeoprocesoOpcionesGenerales
      :capas.sync="capas"
      :metodo.sync="metodo"
      :capasSeleccionadas.sync="capasSeleccionadas"
      :dissolve.sync="dissolve"
    />
  </div>
</template>

<script>
import GeoprocesoBaseMixin from '@/components/mapTools/geoprocessings/mixins/GeoprocesoBaseMixin';
import GeoprocesoDistanciaMixin from '@/components/mapTools/geoprocessings/mixins/GeoprocesoDistanciaMixin';
import GeoprocesoOpcionesGenerales from '@/components/mapTools/geoprocessings/forms/GeoprocesoOpcionesGenerales';
import GeoprocesoSelectorModo from '@/components/mapTools/geoprocessings/forms/GeoprocesoSelectorModo';
import GeoprocesoSelectorCapa from '@/components/mapTools/geoprocessings/forms/GeoprocesoSelectorCapa';

export default {
  name: 'InfluenciaRadialForm',
  components: { GeoprocesoOpcionesGenerales, GeoprocesoSelectorModo, GeoprocesoSelectorCapa },
  mixins: [GeoprocesoBaseMixin, GeoprocesoDistanciaMixin],
  data() {
    return {
      capaOtrasSeleccionada: '',
      seleccionInfo: null,
      radioSeleccionado: 1,
      // 1 m era invisible en el mapa a cualquier zoom de trabajo: se parte de un
      // radio con sentido operativo, que el usuario ajusta.
      distancias: [1000],
      drawActive: false,
    };
  },
  watch: {
    otrasCapas(val) {
      if (val) this.drawActive = false;
    },
  },
  methods: {
    drawPoint() {
      this.drawActive = true;
      // once: la interacción se desactiva al ubicar el punto; sin esto cada
      // click posterior en el mapa re-ubicaba el punto sin querer (mismo
      // comportamiento que la pluma de dispersión)
      this.$emit('changeDrawType', { name: 'Punto', code: 'Point', once: true });
    },
    currentPayload() {
      return {
        ...this.getCommonPayload(),
        radioSeleccionado: this.radioSeleccionado,
        distancias: [...this.distancias],
        radiosValidos: this.radiosValidos,
        mensajeValidacionRadios: this.mensajeValidacionRadios,
        capaOtrasSeleccionada: this.capaOtrasSeleccionada,
        seleccionInfo: this.seleccionInfo,
      };
    },
    onSelectionComplete(data) {
      this.seleccionInfo = data;
      this.emitState();
    },
    refreshRadialBuffer() {
      // El watcher del mixin ajusta primero el largo de `distancias`.
      this.$nextTick(() => {
        this.emitValidDistances();
      });
    },
  },
};
</script>

<style src="./_geoproceso-forms.css"></style>
<style scoped>
.radial-distancias { margin-top: 12px; }
</style>
